export default {"src":"/_next/static/media/TikTok.6ec8b388.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};